export const TREND_ASSETS_CHECKBOXES = [
  { value: 'BS2', color: '#006AA6', isBarChart: true },
  { value: 'FA037', color: '#C3D785', isBarChart: true },
  { value: 'FA038', color: '#AE93E1', isBarChart: true },
  { value: 'BS158', color: '#F5CBA3', isBarChart: true },
  { value: 'FA039', color: '#74B49A', isBarChart: true },
  { value: 'FA040', color: '#E3A2A7', isBarChart: true },
  { value: 'RT0296', color: '#FF596A', isLineChart: true },
  { value: 'RT0172', color: '#00A8B5', isLineChart: true },
]

export const TREND_LIABILITIES_CHECKBOXES = [
  { value: 'BS174', color: '#006AA6', isBarChart: true },
  { value: 'BS175', color: '#C3D785', isBarChart: true },
  { value: 'BS178', color: '#F5CBA3', isBarChart: true },
  { value: 'BS181', color: '#AE93E1', isBarChart: true },
  { value: 'FA047', color: '#74B49A', isBarChart: true },
  { value: 'FA048', color: '#F49966', isLineChart: true },
]

export const TREND_EQUITY_CHECKBOXES = [
  { value: 'BS186', color: '#006AA6', isBarChart: true },
  { value: 'BS187', color: '#C3D785', isBarChart: true },
  { value: 'BS109', color: '#AE93E1', isBarChart: true },
  { value: 'FA054', color: '#F5CBA3', isBarChart: true },
  { value: 'RT0173', color: '#F49966', isLineChart: true },
]

export const EACH_YEAR = {
  ASSETS: [
    { id: 'FA153', color: '#006AA6' },
    { id: 'FA041', color: '#F49966' },
    { id: 'FA042', color: '#00A8B5' },
    { id: 'FA043', color: '#D96383' },
    { id: 'FA044', color: '#74B49A' },
    { id: 'FA045', color: '#7F63B9' },
    { id: 'FA046', color: '#FFCD60' },
  ],
  PARENT_PIE: [
    { id: 'BS65', color: '#0553A5', nameId: 'FA159' },
    { id: 'BS95', color: '#FFCD60', nameId: 'FA160' },
  ],
  CHILD_PIE: {
    BS65: [
      { id: 'FA049', color: '#4EB1CB' },
      { id: 'FA050', color: '#F49966' },
      { id: 'FA051', color: '#717ECD' },
      { id: 'FA052', color: '#C3D785' },
      { id: 'FA053', color: '#EC838C' },
    ],
    BS95: [
      { id: 'FA055', color: '#4EB1CB' },
      { id: 'FA056', color: '#F49966' },
      { id: 'FA057', color: '#C3D785' },
      { id: 'FA058', color: '#EC838C' },
    ],
  },
}

export const TABLE_TABS = [
  {
    label: 'financialAnalysis.ASSET_STRUCTURE',
    key: 0,
    rowIds: [
      'BS2',
      'FA037',
      'FA038',
      'BS158',
      'FA039',
      'FA040',
      'BS64',
      'RT0296',
      'RT0172',
    ],
  },
  {
    label: 'financialAnalysis.LIABILITIES_STRUCTURE',
    key: 1,
    rowIds: ['BS174', 'BS175', 'BS178', 'BS181', 'FA047', 'BS65', 'FA048'],
  },
  {
    label: 'financialAnalysis.EQUITY_STRUCTURE',
    key: 2,
    rowIds: ['BS186', 'BS187', 'BS109', 'FA054', 'BS95', 'RT0173'],
  },
]
